export function formatCurrency(amount) {
    const value = Number(amount) || 0;
    const sign = value < 0 ? '-' : '';
    return `${sign}₹${Math.abs(value).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
}

export function formatPercent(fraction, decimals = 2) {
    const value = Number(fraction) || 0;
    return `${(value * 100).toFixed(decimals)}%`;
}
